import { render } from "./HeroBlock.vue?vue&type=template&id=39470bf4"
import script from "./HeroBlock.vue?vue&type=script&lang=js"
export * from "./HeroBlock.vue?vue&type=script&lang=js"

import "./HeroBlock.vue?vue&type=style&index=0&id=39470bf4&lang=scss"

import exportComponent from "/codebuild/output/src719114813/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__